<template>

  <v-app>

    <v-navigation-drawer
        v-model="drawer"
        app>
      <div style="margin-left:30px" v-on:click="$store.commit('incrementExtras')"><v-img src="/mbsc_logo.png" max-width="100px" ></v-img></div>

      <v-list
          dense
          nav>
        <v-divider></v-divider>
        <v-list-item
            v-for="item in items"
            :key="item.title"
            @click="goTo(item.path)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <template v-if="$store.state.showExtras>5 ">
          <v-list-item
              v-for="item in racing"
              :key="item.title"
              @click="goTo(item.path)"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>
        <template v-if="$store.getters.displayExtras">
        <v-list-item
            v-for="item in admin"
            :key="item.title"
            @click="goTo(item.path)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </template>
      </v-list>

    </v-navigation-drawer>
    <v-app-bar
        app
        color="primary"
        dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <div style="float:left;margin-right:10px;margin-top:5px">
          <v-img src="/mbsc_logo.png" max-width="35px" ></v-img>
        </div>
        <div style="float:left">
          <div>MBSC Team Racing</div>
          <div class="event-heading" v-if="$store.state.event.id"> ({{$store.state.event.id}})</div>
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

  </v-app>
</template>

<script>

export default {
  name: 'CTR',

  created() {
    console.log("event:",this.$store.state.event)
      if (this.$store.state.event === undefined || this.$store.state.event.name===undefined) {
        //this.$router.push({path: "/eventCode"}).catch(()=>{});
        this.submitEventCode();
      }
      document.title="MBSC Team Racing"
  },

  data: () => ({
    drawer: false,
    eventCode: "MBSC-OTC-2022",
    items: [
      {title: "Home", icon: "mdi-view-dashboard", path: "/"},
      {title: "Rounds", icon: "mdi-clipboard-text", path: "/rounds"},
      {title: "Standings", icon: "mdi-account-group", path: "/teams"},
    ],
    racing:[
      {title: "Finish boat", icon: "mdi-ferry", path: "/results"},
    ],
    admin: [
      {title: "Manage rounds", icon: "mdi-cog", path: "/admin"},
      {title: "Event code", icon: "mdi-key-link", path: "/eventCode"},
      {title: "Add Team", icon: "mdi-account-group", path: "/addTeam"},
      {title: "Admin tools", icon: "mdi-key-link", path: "/tools"},
      {title: "Boats", icon: "mdi-sail-boat", path: "/boats"},
    ]
  }),
  methods: {
    goTo: function(path){
      this.$router.push({path: path}).catch(()=>{});
    },
    submitEventCode: function () {
      console.log(this.eventCode);
      this.$store.dispatch('bindEvent',{ id: this.eventCode });
      this.$store.dispatch('bindTeams',{ id: this.eventCode });
      this.$store.dispatch('bindBoatGroups',{ id: this.eventCode });
      this.$store.dispatch('bindRounds',{ id: this.eventCode });
      this.$router.push({path: "/"}).catch(()=>{});
    }
  },
};
</script>
<style>
.event-heading {
  font-size:10px
}
</style>